var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg14(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "191.26mm",
    height: "140.61mm",
    viewBox: "0 0 191.26 140.61",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9529"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.4305e-5 0h960v540h-960z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9553"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9563"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9573"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.0518e-5 540h960v-540l-960 6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9583"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.0518e-5 540h960v-540l-960 6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9597"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m423 141.75h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9607"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9623"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m400.14 217.18 39.67-15.17-15.18-39.67-39.66 15.18z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9633"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9659"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m539.97 215.73 41.23-45.96-45.97-41.23-41.23 45.97z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9669"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9679"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m508.5 196.5h120.75v120.75h-120.75z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9689"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9731"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m336 329.25h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9741"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9759"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m268.5 324h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9769"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9779"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m211.5 329.25h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9789"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-589.64 -400.57)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 546.55 572.17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m122.14 87.857h542.14v398.57h-542.14z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9529)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1,0,0,-1,7.2,495.55)",
    fill: "#000000",
    fontFamily: "TimesNewRomanPSMT",
    fontSize: "36.05px"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 20.224051 37.492001 46.504501 63.772449 79.562347 90.809952 118.56845 134.35835 144.1279 161.39584 177.18575 204.94424 220.73415 230.50369 239.5162 255.99104 272.46591 281.47839 294.20404 312.22906 324.2337 341.53769 359.56271 368.5752 384.36511 412.1236 426.36334 437.61096 449.6156 460.89926",
    y: 0
  }, "Solve mathematical problems (I)"))), /*#__PURE__*/React.createElement("path", {
    d: "m408.38 240.75c0 27.96 22.66 50.62 50.62 50.62s50.63-22.66 50.63-50.62-22.67-50.63-50.63-50.63-50.62 22.67-50.62 50.63z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.38 240.75c0 27.96 22.66 50.62 50.62 50.62s50.63-22.66 50.63-50.62-22.67-50.63-50.63-50.63-50.62 22.67-50.62 50.63z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.38 284.62 25.5 49.5 25.5-49.5z",
    fill: "#4472c4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.38 284.62 25.5 49.5 25.5-49.5z",
    fill: "none",
    stroke: "#2f528f",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.38 139.87 17.99 72h220.51l18-72z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.38 139.87 17.99 72h220.51l18-72z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m425.24 224.84-4.1-13.53c-2.26-7.48-7.78-12.42-12.33-11.04-4.54 1.37-6.39 8.55-4.13 16.03l4.11 13.53z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m425.24 224.84-4.1-13.53c-2.26-7.48-7.78-12.42-12.33-11.04-4.54 1.37-6.39 8.55-4.13 16.03l4.11 13.53z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m503.64 218.79-4.1-13.53c-2.27-7.48-7.79-12.42-12.33-11.04-4.55 1.37-6.4 8.55-4.13 16.02l4.1 13.54z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m503.64 218.79-4.1-13.53c-2.27-7.48-7.79-12.42-12.33-11.04-4.55 1.37-6.4 8.55-4.13 16.02l4.1 13.54z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "m424.09 259.76c0-1.07-0.88-1.94-1.95-1.94-1.08 0-1.95 0.87-1.95 1.94 0 1.08 0.87 1.95 1.95 1.95 1.07 0 1.95-0.87 1.95-1.95z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.32 259.76c0-1.07-0.87-1.94-1.95-1.94s-1.95 0.87-1.95 1.94c0 1.08 0.87 1.95 1.95 1.95s1.95-0.87 1.95-1.95z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9597)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 247.5 106.87)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9607)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m42.384 46.866h11.25v1.5h-11.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.384 42.366h11.25v1.5h-11.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.384 37.866h7.5v1.5h-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.634 54.366h-4.5v3.3c0 0.32-0.203 0.605-0.506 0.709-7.864 2.625-16.363 2.654-24.244 0.083-7.881 2.572-16.38 2.543-24.244-0.082-0.303-0.104-0.506-0.389-0.506-0.71v-3.3h-4.5c-0.4142 0-0.75-0.336-0.75-0.75v-36c0-0.414 0.3358-0.75 0.75-0.75h24.075c0.315-1.319 1.494-2.25 2.85-2.25h4.65c1.356 0 2.535 0.931 2.85 2.25h24.075c0.414 0 0.75 0.336 0.75 0.75v36c0 0.414-0.336 0.75-0.75 0.75zm-6 2.76v-34.425c-7.335 2.223-15.165 2.223-22.5 0v34.425c7.321 2.32 15.179 2.32 22.5 0zm-46.5 0c7.321 2.32 15.179 2.32 22.5 0v-34.425c-7.335 2.223-15.165 2.223-22.5 0zm51.75-38.76h-24c-0.414 0-0.75-0.336-0.75-0.75v-0.075c0-0.787-0.638-1.425-1.425-1.425h-4.65c-0.787 0-1.425 0.638-1.425 1.425v0.075c0 0.414-0.336 0.75-0.75 0.75h-24v34.5h3.75v-31.2c0-0.414 0.336-0.75 0.75-0.75 0.083 0 0.165 0.013 0.244 0.04 7.631 2.545 15.881 2.545 23.512 0 0.013-2e-3 0.025-4e-3 0.038-6e-3 0.055-0.016 0.112-0.025 0.17-0.028 0.012 0 0.024-6e-3 0.036-6e-3s0.019 4e-3 0.028 4e-3c0.057 2e-3 0.113 0.011 0.168 0.026 0.012 0 0.025 4e-3 0.038 8e-3h0.01c7.631 2.545 15.881 2.545 23.512 0 0.079-0.026 0.161-0.039 0.244-0.038 0.414 0 0.75 0.336 0.75 0.75v31.2h3.75z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9623)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.21081 .55085 -.55085 .21081 424.63 162.34)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m65.509 60.259-5.275 5.294c-1.171 1.172-3.07 1.174-4.243 3e-3l-45.078-45.078-4.52-14.112 14.065 4.57 45.049 45.085c1.169 1.171 1.17 3.067 2e-3 4.238zm-14.821-2.124 7.408-7.408-1.602-1.603-7.409 7.409zm-31.082-45.899-8.343-2.7103-1.729 1.7293 2.682 8.376c1.519 1.194 4.182 0.669 6.122-1.27 1.94-1.94 2.465-4.607 1.268-6.125zm-0.208 7.185c-1.341 1.398-3.166 2.23-5.1 2.325l33.727 33.727 7.409-7.407-33.707-33.739c-0.099 1.933-0.932 3.755-2.329 5.094zm45.047 37.661-5.289-5.294-7.408 7.408 5.3 5.3c0.585 0.587 1.535 0.587 2.121 2e-3 1e-3 0 2e-3 -1e-3 2e-3 -2e-3l5.276-5.293c0.585-0.586 0.584-1.536-2e-3 -2.121z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m421.88 253.12c0 9.12 7.55 16.5 16.87 16.5s16.88-7.38 16.88-16.5c0-9.11-7.56-16.5-16.88-16.5s-16.87 7.39-16.87 16.5z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.88 253.12c0 9.12 7.55 16.5 16.87 16.5s16.88-7.38 16.88-16.5c0-9.11-7.56-16.5-16.88-16.5s-16.87 7.39-16.87 16.5z",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.13 253.12c0 9.12 7.55 16.5 16.87 16.5s16.88-7.38 16.88-16.5c0-9.11-7.56-16.5-16.88-16.5s-16.87 7.39-16.87 16.5z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.13 253.12c0 9.12 7.55 16.5 16.87 16.5s16.88-7.38 16.88-16.5c0-9.11-7.56-16.5-16.88-16.5s-16.87 7.39-16.87 16.5z",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m441.01 247.89c0-1.08-0.87-1.95-1.95-1.95s-1.95 0.87-1.95 1.95c0 1.07 0.87 1.95 1.95 1.95s1.95-0.88 1.95-1.95z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m467.34 247.12c0-1.07-0.87-1.95-1.95-1.95-1.07 0-1.94 0.88-1.94 1.95 0 1.08 0.87 1.95 1.94 1.95 1.08 0 1.95-0.87 1.95-1.95z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m466.13 228c0-5.59-7.22-10.13-16.13-10.13s-16.12 4.54-16.12 10.13h5.06c0-2.8 4.95-5.06 11.06-5.06s11.06 2.26 11.06 5.06z",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m466.13 228c0-5.59-7.22-10.13-16.13-10.13s-16.12 4.54-16.12 10.13h5.06c0-2.8 4.95-5.06 11.06-5.06s11.06 2.26 11.06 5.06z",
    fill: "none",
    stroke: "#a5a5a5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9659)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.63839 -.57263 .57263 -.63839 539.97 215.73)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m49.884 46.866h-27v12h27zm0-10.5h-4.5v4.5h4.5zm0-7.5h-4.5v4.5h4.5zm0-7.5h-4.5v4.5h4.5zm0-7.5h-4.5v4.5h4.5zm-7.5 22.5h-4.5v4.5h4.5zm0-7.5h-4.5v4.5h4.5zm0-7.5h-4.5v4.5h4.5zm0-7.5h-4.5v4.5h4.5zm-7.5 22.5h-4.5v4.5h4.5zm0-7.5h-4.5v4.5h4.5zm0-7.5h-4.5v4.5h4.5zm0-7.5h-12v4.5h12zm-12 12h4.5v-4.5h-4.5zm0 7.5h4.5v-4.5h-4.5zm0 7.5h4.5v-4.5h-4.5zm31.5 25.5h-36c-1.65 0-3-1.35-3-3v-54c0-1.65 1.35-3 3-3h36c1.65 0 3 1.35 3 3v54c0 1.65-1.35 3-3 3z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9679)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.6771,-1.88e-7,-7.54e-7,1.6771,508.5,196.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9689)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.633 57.361h-1.5v-34.509h52.502v34.509zm49.502-33.009h-49.502v31.509h49.502z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.385 61.112h-54.002c-1.655-5e-3 -2.9953-1.346-3-3.001v-36.01c0.0047-1.655 1.345-2.996 3-3.001h21.749v-7.502h-8.249v-1.5h27.002v1.5h-8.253v7.502h21.753c1.655 6e-3 2.995 1.346 3 3.001v36.01c-5e-3 1.655-1.345 2.996-3 3.001zm-23.253-49.514h-7.5v7.502h7.5zm24.753 10.503c0-0.828-0.671-1.499-1.5-1.501h-54.002c-0.8283 2e-3 -1.4992 0.673-1.5 1.501v36.01c8e-4 0.829 0.6717 1.5 1.5 1.501h54.002c0.828-1e-3 1.499-0.672 1.5-1.501z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.502 41.257h1.5v4.305h4.305v1.5h-4.305v4.306h-1.5v-4.306h-4.306v-1.5h4.306z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.463 47.062h10.111v-1.5h-10.111z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.653 37.824-3.402-3.402-3.401 3.402-1.061-1.061 3.402-3.402-3.402-3.402 1.061-1.06 3.401 3.402 3.402-3.402 1.061 1.06-3.402 3.402 3.402 3.402z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.463 34.112h10.111v-1.5h-10.111z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.83 36.732c0-0.724-0.587-1.312-1.312-1.312-0.724 0-1.311 0.588-1.311 1.312 0 0.725 0.587 1.312 1.311 1.312 0.725 0 1.312-0.587 1.312-1.312z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.83 29.991c0-0.724-0.587-1.312-1.312-1.312-0.724 0-1.311 0.588-1.311 1.312s0.587 1.312 1.311 1.312c0.725 0 1.312-0.588 1.312-1.312z"
  }))))), /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m414.15 395.5c3.31 20.25-13.76 38.91-38.14 41.66-9.88 1.12-19.93-0.55-28.53-4.74-9.12 14.28-30.42 19.7-47.58 12.12-3-1.33-5.75-3.01-8.17-4.99-7.1 11.84-24.39 16.64-38.63 10.74-3.93-1.63-7.37-4-10.04-6.91-11.44 11.19-31.66 12.58-45.16 3.09-5.68-3.99-9.5-9.49-10.82-15.55-18.75-4.25-29.81-20.35-24.7-35.97 0.43-1.31 0.97-2.59 1.61-3.84-15.04-16.27-11.36-39.58 8.22-52.08 6.1-3.88 13.29-6.4 20.9-7.31 0.17-17.5 17.39-31.57 38.47-31.43 7.04 0.05 13.93 1.71 19.9 4.81 7.13-19.62 32-30.71 55.55-24.77 9.86 2.49 18.39 7.76 24.12 14.9 24.11-12.09 55.4-5.59 69.89 14.51 0.18 0.26 0.36 0.51 0.54 0.77 15.78-1.53 30.07 7.82 31.92 20.89 0.99 6.97-1.78 13.95-7.57 19.07 13.66 6.69 18.25 21.35 10.25 32.77-4.61 6.58-12.71 10.93-21.79 11.71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m351.92 257.63c0-2.67 2.16-4.84 4.83-4.84s4.83 2.17 4.83 4.84c0 2.66-2.16 4.83-4.83 4.83s-4.83-2.17-4.83-4.83z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m343.86 263.54c0-5.34 4.32-9.67 9.66-9.67s9.67 4.33 9.67 9.67c0 5.33-4.33 9.66-9.67 9.66s-9.66-4.33-9.66-9.66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331.16 277.93c0-8.01 6.5-14.5 14.5-14.5 8.01 0 14.5 6.49 14.5 14.5s-6.49 14.5-14.5 14.5c-8 0-14.5-6.49-14.5-14.5z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m414.15 395.5c3.31 20.25-13.76 38.91-38.14 41.66-9.88 1.12-19.93-0.55-28.53-4.74-9.12 14.28-30.42 19.7-47.58 12.12-3-1.33-5.75-3.01-8.17-4.99-7.1 11.84-24.39 16.64-38.63 10.74-3.93-1.63-7.37-4-10.04-6.91-11.44 11.19-31.66 12.58-45.16 3.09-5.68-3.99-9.5-9.49-10.82-15.55-18.75-4.25-29.81-20.35-24.7-35.97 0.43-1.31 0.97-2.59 1.61-3.84-15.04-16.27-11.36-39.58 8.22-52.08 6.1-3.88 13.29-6.4 20.9-7.31 0.17-17.5 17.39-31.57 38.47-31.43 7.04 0.05 13.93 1.71 19.9 4.81 7.13-19.62 32-30.71 55.55-24.77 9.86 2.49 18.39 7.76 24.12 14.9 24.11-12.09 55.4-5.59 69.89 14.51 0.18 0.26 0.36 0.51 0.54 0.77 15.78-1.53 30.07 7.82 31.92 20.89 0.99 6.97-1.78 13.95-7.57 19.07 13.66 6.69 18.25 21.35 10.25 32.77-4.61 6.58-12.71 10.93-21.79 11.71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m351.92 257.63c0-2.67 2.16-4.84 4.83-4.84s4.83 2.17 4.83 4.84c0 2.66-2.16 4.83-4.83 4.83s-4.83-2.17-4.83-4.83z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m343.86 263.54c0-5.34 4.32-9.67 9.66-9.67s9.67 4.33 9.67 9.67c0 5.33-4.33 9.66-9.67 9.66s-9.66-4.33-9.66-9.66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331.16 277.93c0-8.01 6.5-14.5 14.5-14.5 8.01 0 14.5 6.49 14.5 14.5s-6.49 14.5-14.5 14.5c-8 0-14.5-6.49-14.5-14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.91 347.94c5.84-0.38 11.67 0.74 16.72 3.21m-31.46-38.34c2.34-0.78 4.8-1.29 7.31-1.54m-70.31-15.34c1.76 2.2 3.24 4.55 4.4 7.01m-85.87 10.47c0.26-2.61 0.85-5.19 1.76-7.69m-36.74 55.2c-13.22-5.35-21.57-16.53-21.45-28.74m-29.15 59.35c2.15-4.16 5.42-7.84 9.56-10.77m13.36 50.76c-0.36-1.68-0.53-3.38-0.5-5.09m61.5 11.03c-1.24 2.35-2.89 4.53-4.89 6.49m50.66-9.59c-0.51 1.94-1.31 3.82-2.37 5.6m56.07-7.5c-3.11-1.51-5.99-3.34-8.57-5.43m73.71-37.25c0.68 1.87 1.18 3.78 1.49 5.71"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9731)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,329.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9741)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.382 61.866h-1.5v-51h50.977v1.5h-49.477z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.884 16.854v29.257h-9v-29.257zm-7.5 27.757h6v-26.257h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.884 16.854v45.012h-9v-45.012zm-7.5 43.512h6v-42.012h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.884 16.854v29.257h-9v-29.257zm-7.5 27.757h6v-26.257h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.884 16.854h9v16.504h-9zm1.5 15.004h6v-13.504h-6z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9759)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(268.5,324)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36.384 64.866c-15.74 0-28.5-12.76-28.5-28.5s12.76-28.5 28.5-28.5 28.5 12.76 28.5 28.5-12.76 28.5-28.5 28.5zm26.981-27.75h-26.231v26.231c14.312-0.414 25.817-11.919 26.231-26.231zm-53.981-0.75c0.0183 14.611 11.645 26.562 26.25 26.981v-27.292l19.29-19.29c-10.813-10.25-27.89-9.7945-38.141 1.019-4.756 5.017-7.4044 11.669-7.399 18.582zm46.6-18.54-17.775 17.775c-6e-3 7e-3 -4e-3 0.013 6e-3 0.013h25.15c-0.18-6.637-2.809-12.973-7.381-17.788z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9779)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(211.5,329.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m55.884 66.366h-39c-2.07-3e-3 -3.748-1.68-3.75-3.75v-52.5c2e-3 -2.0701 1.68-3.7475 3.75-3.75h39c2.07 0.0025 3.748 1.6799 3.75 3.75v52.5c-2e-3 2.07-1.68 3.747-3.75 3.75zm-39-1.5h39c1.243 0 2.25-1.007 2.25-2.25v-7.5h-6.75v0.75c0 1.657-1.343 3-3 3s-3-1.343-3-3v-0.75h-1.5v0.75c0 1.657-1.343 3-3 3s-3-1.343-3-3v-0.75h-10.5v0.75c0 1.657-1.343 3-3 3s-3-1.343-3-3v-0.75h-6.75v7.5c0 1.243 1.007 2.25 2.25 2.25zm31.5-42c-1.657 0-3-1.343-3-3v-0.75h-1.5v0.75c0 1.657-1.343 3-3 3s-3-1.343-3-3v-0.75h-10.5v0.75c0 1.657-1.343 3-3 3s-3-1.343-3-3v-0.75h-6.75v10.5h6.75v-0.75c0-1.657 1.343-3 3-3s3 1.343 3 3v0.75h1.5v-0.75c0-1.657 1.343-3 3-3s3 1.343 3 3v0.75h10.5v-0.75c0-1.657 1.343-3 3-3s3 1.343 3 3v0.75h6.75v-10.5h-6.75v0.75c0 1.657-1.343 3-3 3zm1.5-3v-3c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5v3c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5zm-7.5 0v-3c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5v3c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5zm-16.5 0v-3c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5v3c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5zm-3 9v3c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5v-3c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5zm7.5 0v3c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5v-3c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5zm16.5 0v3c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5v-3c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5zm4.5 2.25v0.75c0 1.657-1.343 3-3 3s-3-1.343-3-3v-0.75h-10.5v0.75c0 1.657-1.343 3-3 3s-3-1.343-3-3v-0.75h-1.5v0.75c0 1.657-1.343 3-3 3s-3-1.343-3-3v-0.75h-6.75v10.5h15.75v-0.75c0-1.657 1.343-3 3-3s3 1.343 3 3v0.75h1.5v-0.75c0-1.657 1.343-3 3-3s3 1.343 3 3v0.75h1.5v-0.75c0-1.657 1.343-3 3-3s3 1.343 3 3v0.75h6.75v-10.5zm-19.5 9.75v3c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5v-3c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5zm7.5 0v3c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5v-3c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5zm7.5 0v3c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5v-3c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5zm4.5 2.25v0.75c0 1.657-1.343 3-3 3s-3-1.343-3-3v-0.75h-1.5v0.75c0 1.657-1.343 3-3 3s-3-1.343-3-3v-0.75h-1.5v0.75c0 1.657-1.343 3-3 3s-3-1.343-3-3v-0.75h-15.75v10.5h6.75v-0.75c0-1.657 1.343-3 3-3s3 1.343 3 3v0.75h10.5v-0.75c0-1.657 1.343-3 3-3s3 1.343 3 3v0.75h1.5v-0.75c0-1.657 1.343-3 3-3s3 1.343 3 3v0.75h6.75v-10.5zm-28.5 9.75v3c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5v-3c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5zm16.5 0v3c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5v-3c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5zm7.5 0v3c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5v-3c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5zm9-45h-39c-1.243 0-2.25 1.0073-2.25 2.25v7.5h6.75v-0.75c0-1.657 1.343-3 3-3s3 1.343 3 3v0.75h10.5v-0.75c0-1.657 1.343-3 3-3s3 1.343 3 3v0.75h1.5v-0.75c0-1.657 1.343-3 3-3s3 1.343 3 3v0.75h6.75v-7.5c0-1.2427-1.007-2.25-2.25-2.25z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m575.63 117.01v24.36",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 5.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.63 117.01v24.36",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 5.25
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg14);
export default __webpack_public_path__ + "static/media/14.61a32353f2af105542a438aede22ba7e.svg";
export { ForwardRef as ReactComponent };